export default "__VITE_ASSET__BFjo3jju__"